export default "__VITE_ASSET__BtZqEAso__"